import { helper } from '@ember/component/helper';

export default helper(function callHelper([ fn, ...args ], hash) {
  const { context, defaultValue } = hash;
  fn = context && typeof fn !== 'function' ? context[fn] : fn;
  let result;
  if (typeof fn === 'function') {
    result = fn.call(context, ...args);
  } else {
    result = defaultValue;
  }
  return result;
});
